import React from "react";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PersistGate } from "redux-persist/integration/react";
import 'firebase/firestore';
import rootReducer from './reducers/rootReducer';

import routes from "./routes";

import {FIREBASE_CONFIG} from './environmentVariables';

import './scss/custom.scss';

const app = initializeApp(FIREBASE_CONFIG);
export const analytics = getAnalytics(app);
export const fbstorage = getStorage(app);
export const functions = getFunctions(app);

if (process.env.REACT_APP_USE_EMULATOR === 'true') {
  console.log('[EnforcePlus Payment] Connecting to Firebase Functions Emulator');
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

const middleware = [thunk];
// Logger will only run in development mode __DEV__ is a NPM global constant
if (process.env.NODE_ENV === 'development') {
  const loggerMiddleware = createLogger();
  middleware.push(loggerMiddleware);
}

const persistConfig = {
  key: "root",
  storage,
  //blacklist: ["general"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(persistedReducer, {}, composeEnhancers(applyMiddleware(...middleware)));
const persistor = persistStore(store);

export default () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router basename={process.env.REACT_APP_BASENAME || ""}>
        <Routes>
          {routes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                element={
                  <route.layout>
                    <route.component />
                  </route.layout>
                }
              />
            );
          })}
        </Routes>
      </Router>
    </PersistGate>
  </Provider>
);
